declare const $, moment, angular: ng.IAngularStatic, console, document, Math;
declare var require: any;

import { enviorment } from '../../enviorment';

import { appRoute } from './route/route';

import { ecbRun } from './ecb.run';
import { constant } from './ecb.constant';

// Load DNN Modules Components
import { userProfileComponent } from '../../components/user-profile/user-profile';
import { bazaryab_adminComponent } from '../../components/bazaryab-admin/bazaryab-admin';
import { bazaryab_admin_menu_component } from './../../components/bazaryab-admin-menu/bazaryab-admin-menu';

import { MdTooltipDirective } from '../../directives/ecbTooltip/ecbTooltip';
import { customScrollbar } from '../../directives/customScrollBar/customScrollBar';
import { browsCategoryComponent } from '../../components/browsCategory/browsCategory.component';
import { browsProductComponent } from '../../components/browsProduct/browsProduct.component';
import { browsProductTypeComponent } from '../../components/browsProductType/browsProductType.component';
import { browsCityComponent } from '../../components/browsCity/browsCity.component';
import { carouselComponent } from '../../components/carousel/carousel';
import { gridListComponent } from '../../components/grid-list/grid-list';
import { paginationComponent } from '../../components/pagination/pagination';
import { productListComponent } from '../../components/product-list/product-list';
import { productComponent } from '../../components/product/product';
import { productGridViewComponent } from '../../components/product-grid-view/product-grid-view';
import { productlistViewComponent } from '../../components/product-list-view/product-list-view';
import { storeCartComponent } from '../../components/store-cart/store-cart';
import { storeMinCartComponent } from '../../components/store-min-cart/store-min-cart';
import { storeSearchComponent } from '../../components/store-search/store-search';
import { storeManagementComponent } from '../../components/store-management/store-management';
import { storeQuickAccessComponent } from '../../components/store-quick-access/store-quick-access';
import { storeCompareComponent } from '../../components/store-compare/store-compare';
import { storeRegistrationComponent } from '../../components/store-registration/store-registration';
import { loginViewComponent } from '../../components/login-view/login-view';
import { compareFormComponent } from '../../components/compare-form/compare-form';
import { slide_show_component } from '../../components/slide-show/slide-show';
import { count_down_timer_component } from '../../components/count-down-timer/count-down-timer';
import { store_carousel_component } from '../../components/store-carousel/store-carousel';
import { store_carousel_grid_component } from '../../components/store-carousel-grid/store-carousel-grid';
import { store_carousel_list_component } from '../../components/store-carousel-list/store-carousel-list';
import { store_carousel_carousel_component } from '../../components/store-carousel-carousel/store-carousel-carousel';

import { tranlatesFilter } from '../../filters/translates/translates.filter';
import { enumsFilter } from '../../filters/enums/enums.filter';
import { enumToSelect_filter } from '../../filters/enumToSelect/enumToSelect';

import { modulePathService } from '../../services/modulePath/modulePath';
import { userService } from '../../services/user/user';
import { compareService } from '../../services/compare/compare';
import { notifyService } from '../../services/notify/notify';
import { cartService } from '../../services/cart/cart';
import { orderService } from '../../services/order/order';

import { profileFactory } from '../../factories/profile/profile';
import { favoritFactory } from '../../factories/favorit/favorit';
import { vendorInfoFactory } from '../../factories/vendor-info/vendor-info';
import { availableFactory } from '../../factories/available-alert/available-alert';
import { search_factory } from '../../factories/search/search';
import { amazingOffer_factory } from '../../factories/amazingOffer/amazingOffer';

import { toggleMenu_directive } from '../../directives/toggleMenu/toggleMenu';
import { collapsed_directive } from '../../directives/collapsed/collapsed';
import { clickOutSide_directive } from '../../directives/clickOutSide/clickOutSide';
import { backdropBasket_directive } from '../../directives/backdrop-basket/backdrop-basket';
import { count_down_timer_directive } from '../../directives/count-down-timer/count-down-timer';
import { logistic_component } from '../../components/logistic/logistic';
import { checkout_login_component } from '../../components/checkout-login/checkout-login';
import { geoFactory } from '../../factories/geo/geo';
import { validate_directive } from '../../directives/validate/validate';
import { OwlCarouselDirective } from '../../directives/owlcarousel/owlcarousel';

function Filter() {
  return FilterFn;

  function FilterFn(Params) {
    if (Params || Params === 0) {
      return Params.toString().replace(/\d+/g, function(digit) {
        var enDigitArr = [],
          peDigitArr = [];
        for (var i = 0; i < digit.length; i++) {
          enDigitArr.push(digit.charCodeAt(i));
        }
        for (var j = 0; j < enDigitArr.length; j++) {
          peDigitArr.push(
            String.fromCharCode(
              enDigitArr[j] + (!!Params && Params === true ? 1584 : 1728)
            )
          );
        }
        return peDigitArr.join('');
      });
    } else {
      return Params;
    }
  }
}

function formatAsCurrency() {
  return {
    scope: {
      model: '=ngModel'
    },
    link: function(scope, element, attr) {
      scope.$watch(
        function() {
          return $(element).val();
        },
        function() {
          var num = $(element)
            .val()
            .replace(/[^\d]/g, '');
          if (num.length > 3) {
            num = num.replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
          } else {
            num = num.replace(/\,/g, '');
          }
          scope.model = num.replace(/\,/g, '');
          $(element).val(num);
        }
      );
    }
  };
}

function sepnaLoadingDirective() {
  return {
    restrict: 'E',
    template: `<md-progress-circular class="md-primary md-hue-1" md-diameter="30"></md-progress-circular>`,
    scope: {
      ngIf: '='
    },
    link: function(scope, element, attrs) {
      $(element)
        .parent()
        .css({ position: 'relative' });
    }
  };
}
$(document).ready(function() {
  var app = angular.module('store-app', ['vendor']);

  app.constant('MyConstant', constant);

  app.run(ecbRun);
  app.config(lazyConfig);
  function lazyConfig($ocLazyLoadProvider) {
    'ngInject';

    let baseUrl = 'http://static.bazaryab.dev';
    if (enviorment.mode == 'demo') {
      baseUrl = 'https://static.bazaryab.com/demo';
    } else if (enviorment.mode == 'dist') {
      baseUrl = 'https://static.bazaryab.com/dist';
    }

    $ocLazyLoadProvider.config({
      modules: [
        {
          name: 'product-detail',
          files: [
            `${baseUrl}/modules/product-detail/product-detail.js?cdv=${cdv}`,
            `${baseUrl}/modules/product-detail/product-detail.css?cdv=${cdv}`,
            `${baseUrl}/ckeditor/ckeditor.js?cdv=${cdv}`
          ]
        },
        {
          name: 'user-profile',
          files: [
            `${baseUrl}/modules/user-profile/user-profile.js?cdv=${cdv}`,
            `${baseUrl}/modules/user-profile/user-profile.css?cdv=${cdv}`
          ]
        },
        {
          name: 'list-by-cat',
          files: [
            `${baseUrl}/modules/list-by-cat/list-by-cat.js?cdv=${cdv}`,
            `${baseUrl}/modules/list-by-cat/list-by-cat.css?cdv=${cdv}`
          ]
        },
        {
          name: 'list-by-type',
          files: [
            `${baseUrl}/modules/list-by-type/list-by-type.js?cdv=${cdv}`,
            `${baseUrl}/modules/list-by-type/list-by-type.css?cdv=${cdv}`
          ]
        },
        {
          name: 'list-by-vendor',
          files: [
            `${baseUrl}/modules/list-by-vendor/list-by-vendor.js?cdv=${cdv}`,
            `${baseUrl}/modules/list-by-vendor/list-by-vendor.css?cdv=${cdv}`
          ]
        },
        {
          name: 'checkout',
          files: [
            `${baseUrl}/modules/checkout/checkout.js?cdv=${cdv}`,
            `${baseUrl}/modules/checkout/checkout.css?cdv=${cdv}`
          ]
        },
        {
          name: 'search-result',
          files: [
            `${baseUrl}/modules/search-result/search-result.js?cdv=${cdv}`,
            `${baseUrl}/modules/search-result/search-result.css?cdv=${cdv}`
          ]
        },
        {
          name: 'management',
          files: [
            `${baseUrl}/modules/management/management.js?cdv=${cdv}`,
            `${baseUrl}/modules/management/management.css?cdv=${cdv}`,
            `${baseUrl}/ckeditor/ckeditor.js?cdv=${cdv}`
          ]
        },
        {
          name: 'bazaryab-admin',
          files: [
            `${baseUrl}/modules/bazaryab-admin/bazaryab-admin.js?cdv=${cdv}`,
            `${baseUrl}/modules/bazaryab-admin/bazaryab-admin.css?cdv=${cdv}`
          ]
        },
        {
          name: 'registration',
          files: [
            `${baseUrl}/modules/registration/registration.js?cdv=${cdv}`,
            `${baseUrl}/modules/registration/registration.css?cdv=${cdv}`
          ]
        },
        {
          name: 'logistic',
          files: [
            `${baseUrl}/modules/logistic/logistic.js?cdv=${cdv}`,
            `${baseUrl}/modules/logistic/logistic.css?cdv=${cdv}`
          ]
        }
      ],
      events: true
    });
  }

  app.config(function($stateProvider, $locationProvider, MyConstant) {
    'ngInject';

    $locationProvider.html5Mode(true);
    $stateProvider
      .state('product-detail', {
        url: '/pID/:pID',
        component: 'storeProductDetail',
        resolve: {
          // Any property in resolve should return a promise and is executed before the view is loaded
          loadMyCtrl: function($ocLazyLoad) {
            'ngInject';
            return $ocLazyLoad.load('product-detail');
          }
        }
      })
      .state('product-detail-with-name', {
        url: '/pID/:pID/:pName',
        component: 'storeProductDetail',
        resolve: {
          // Any property in resolve should return a promise and is executed before the view is loaded
          loadMyCtrl: '$ocLazyLoad',
          function($ocLazyLoad) {
            'ngInject';
            return $ocLazyLoad.load('product-detail');
          }
        }
      })

      .state('listByCatRedirect', {
        url: '/catID/:catID',
        params: {
          catID: { raw: true, dynamic: true }
        },
        views: {
          list: {
            template:
              '<div style="min-height:300px"><spn-loading></spn-loading></div>',
            controller: function($state) {
              $state.params.params = 'pageNumber/1/';
              $state.go('listByCat', $state.params);
            }
          }
        }
      })
      .state('listByCat', {
        url: '/catID/:catID/:params',
        params: {
          params: { type: 'string', raw: true, value: null, dynamic: true },
          catID: { raw: true, dynamic: true }
        },
        views: {
          list: {
            component: 'storeListByCat'
          },
          'filter@': {
            component: 'storeListByCatFilter'
          }
        },
        resolve: {
          // Any property in resolve should return a promise and is executed before the view is loaded
          loadMyCtrl: function($ocLazyLoad) {
            'ngInject';
            return $ocLazyLoad.load('list-by-cat');
          }
        }
      })

      .state('listByTypeRedirect', {
        url: '/productTypeID/:productTypeID',
        params: {
          productTypeID: { raw: true, dynamic: true }
        },
        views: {
          list: {
            template:
              '<div style="min-height:300px"><spn-loading></spn-loading></div>',
            controller: function($state) {
              $state.params.params = 'pageNumber/1/';
              $state.go('listByType', $state.params);
            }
          }
        }
      })
      .state('listByType', {
        url: '/productTypeID/:productTypeID/:params',
        params: {
          params: { type: 'string', raw: true, value: null, dynamic: true },
          productTypeID: { raw: true, dynamic: true }
        },
        views: {
          list: {
            component: 'storeListByType'
          },
          'filter@': {
            component: 'storeListByTypeFilter'
          }
        },
        resolve: {
          // Any property in resolve should return a promise and is executed before the view is loaded
          loadMyCtrl: function($ocLazyLoad) {
            'ngInject';
            return $ocLazyLoad.load('list-by-type');
          }
        }
      })
      .state('listByVendorRedirect', {
        url: '/VendorID/:vendorId',
        params: {
          vendorId: { raw: true, dynamic: true }
        },
        views: {
          list: {
            template:
              '<div style="min-height:300px"><spn-loading></spn-loading></div>',
            controller: function($state) {
              $state.params.params = 'pageNumber/1/';
              $state.go('listByVendor', $state.params);
            }
          }
        }
      })
      .state('listByVendorWithCategory', {
        url: '/VendorID/:vendorId/CatID/:CatID/:params',
        params: {
          params: { type: 'string', raw: true, value: null, dynamic: true },
          vendorId: { raw: true, dynamic: true },
          CatID: { raw: true, dynamic: true }
        },
        views: {
          list: {
            component: 'storeListByVendor'
          },
          'filter@': {
            component: 'storeListByVendorFilter'
          }
        },
        resolve: {
          // Any property in resolve should return a promise and is executed before the view is loaded
          loadMyCtrl: function($ocLazyLoad) {
            'ngInject';
            return $ocLazyLoad.load('list-by-vendor');
          }
        }
      })
      .state('listByVendorWithProductType', {
        url: '/VendorID/:vendorId/ProductTypeID/:ProductTypeID/:params',
        params: {
          params: { type: 'string', raw: true, value: null, dynamic: true },
          vendorId: { raw: true, dynamic: true },
          ProductTypeID: { raw: true, dynamic: true }
        },
        views: {
          list: {
            component: 'storeListByVendor'
          },
          'filter@': {
            component: 'storeListByVendorFilter'
          }
        },
        resolve: {
          // Any property in resolve should return a promise and is executed before the view is loaded
          loadMyCtrl: function($ocLazyLoad) {
            'ngInject';
            return $ocLazyLoad.load('list-by-vendor');
          }
        }
      })
      .state('listByVendor', {
        url: '/VendorID/:vendorId/:params',
        params: {
          params: { type: 'string', raw: true, value: null, dynamic: true },
          vendorId: { raw: true, dynamic: true }
        },
        views: {
          list: {
            component: 'storeListByVendor'
          },
          'filter@': {
            component: 'storeListByVendorFilter'
          }
        },
        resolve: {
          // Any property in resolve should return a promise and is executed before the view is loaded
          loadMyCtrl: function($ocLazyLoad) {
            'ngInject';
            return $ocLazyLoad.load('list-by-vendor');
          }
        }
      })

      .state('invalidVendor', {
        url: '/VendorID/invalidVendor',
        views: {
          list: {
            template:
              '<div class="alert alert-warning text-center m-t-20">این فروشگاه هنوز تایید نشده است</br><a class="text-center btn btn-default " href="/">بازگشت</a></div>'
          }
        },
        resolve: {
          // Any property in resolve should return a promise and is executed before the view is loaded
          loadMyCtrl: function($ocLazyLoad) {
            'ngInject';
            return $ocLazyLoad.load('list-by-vendor');
          }
        }
      })
      .state('bankResult', {
        url: '/BankResult/:transactionId',
        views: {
          'store-checkout': {
            component: 'checkoutBankresult'
          }
        },
        resolve: {
          // Any property in resolve should return a promise and is executed before the view is loaded
          loadMyCtrl: function($ocLazyLoad) {
            'ngInject';
            return $ocLazyLoad.load('checkout');
          }
        }
      })
      .state('checkout', {
        url: '/order/:orderId',
        views: {
          'store-checkout': {
            component: 'checkout'
          }
        },
        resolve: {
          // Any property in resolve should return a promise and is executed before the view is loaded
          loadMyCtrl: function($ocLazyLoad) {
            'ngInject';
            return $ocLazyLoad.load('checkout');
          }
        }
      })
      .state('login', {
        parent: 'checkout',
        url: '/login?compeleteInfo',
        template: '<checkout-login></checkout-login>'
        // component: 'checkoutShipping'
      })
      .state('address', {
        parent: 'checkout',
        url: '/address',
        component: 'checkoutAddress'
      })
      .state('shipping', {
        parent: 'checkout',
        url: '/shipping',
        component: 'checkoutShipping'
      })
      .state('review', {
        parent: 'checkout',
        url: '/review',
        component: 'checkoutReview'
      })
      .state('payment', {
        parent: 'checkout',
        url: '/payment',
        component: 'checkoutPayment'
      })
      .state('finish', {
        parent: 'checkout',
        url: '/finish',
        component: 'checkoutFinish'
      })

      .state('resultRedirect', {
        url: '/keyword/:keyword',
        params: {
          keyword: { raw: true, dynamic: true }
        },
        controller: function($state) {
          $state.params.params = 'pageNumber/1/';
          $state.go('result', $state.params);
        }
      })
      .state('result', {
        url: '/keyword/:keyword/:params',
        params: {
          params: { type: 'string', raw: true, value: null, dynamic: true },
          keyword: { raw: true, dynamic: true }
        },
        component: 'storeSearchResult',
        resolve: {
          // Any property in resolve should return a promise and is executed before the view is loaded
          loadMyCtrl: function($ocLazyLoad) {
            'ngInject';
            return $ocLazyLoad.load('search-result');
          }
        }
      })
      .state('management', {
        abstract: true,
        template: '<div ui-view><div>'
      })

      .state('storeSetting', {
        parent: 'management',
        url: '/storeSetting',
        templateUrl: `${MyConstant.TemplateUrl}management/storeSetting.html`,
        controller: 'StoreSettingCtrl'
      })
      .state('storeSetting.StoreInfo', {
        url: '/StoreInfo',
        component: 'storeInfo'
      })
      .state('storeSetting.WarantyInfo', {
        url: '/WarantyInfo',
        component: 'warantyInfo'
      })
      .state('storeSetting.shippment', {
        url: '/shippment',
        component: 'storeAdminShippment'
      })
      .state('storeSetting.shippment.list', {
        url: '/list',
        component: 'storeAdminShippmentList'
      })
      .state('storeSetting.shippment.create', {
        url: '/create',
        component: 'storeAdminShippmentCreate'
      })
      .state('storeSetting.shippment.edit', {
        url: '/:id',
        component: 'storeAdminShippmentEdit'
      })
      .state('storeSetting.shippment.config', {
        url: '/:id/:vendorId/config',
        component: 'storeAdminShippmentConfig'
      })
      .state('storeSetting.shippment.config.list', {
        url: '/list',
        component: 'storeAdminShippmentConfigList'
      })
      .state('storeSetting.shippment.config.create', {
        url: '/create',
        component: 'storeAdminShippmentConfigCreate'
      })
      .state('storeSetting.shippment.config.edit', {
        url: '/:assignmentId',
        component: 'storeAdminShippmentConfigEdit'
      })
      .state('storeSetting.PaymentMethod', {
        url: '/PaymentMethod',
        component: 'paymentMethod'
      })

      .state('selectProduct', {
        parent: 'management',
        url: '/selectProduct',
        templateUrl: `${MyConstant.TemplateUrl}management/selectProduct.html`,
        controller: 'ecb.app.vendorAdmin.selectProduct.controller'
      })
      .state('manageProduct', {
        parent: 'management',
        url: '/manageProduct',
        controller: 'ecb.app.vendorAdmin.manageProduct.controller',
        templateUrl: `${MyConstant.TemplateUrl}management/manageProduct.html`
      })

      .state('fastPricing', {
        parent: 'management',
        url: '/manageProduct/ProductID/:ProductID',
        controller: 'ecb.app.vendorAdmin.FastAccess.controller',
        template: `Loading...`
      })
      .state('fasteditPrice', {
        parent: 'management',
        url: '/manageProduct/ProductID/:ProductID/salabelItemID/:salabelItemID',
        controller: ($mdDialog, $state, $location) => {
          'ngInject';
          $mdDialog
            .show({
              controller: function() {
                this.SalableItem = {
                  productId: $state.params.ProductID,
                  SalableItemID: $state.params.salabelItemID
                };
              },
              controllerAs: 'dialog',
              template:
                '<management-price-form salable-item="dialog.SalableItem"></management-price-form>',
              parent: angular.element(document.body),
              // targetEvent: ev,
              fullscreen: true,
              clickOutsideToClose: true
            })
            .then(
              response => {
                $location.path('/manageProduct');
              },
              reject => {
                $location.path('/manageProduct');
              }
            );
        },
        template: `Loading...`
      })

      .state('fastEditing', {
        parent: 'management',
        url: '/selectProduct/ProductID/:ProductID',
        controller: 'ecb.app.vendorAdmin.fastEditProduct.controller',
        template: `Loading...`
      })
      // route for Orders
      .state('orders', {
        parent: 'management',
        url: '/orders',
        component: 'storeAdminOrders'
      })
      .state('orders.detail', {
        url: '/:orderId',
        component: 'storeAdminOrdersDetail'
      })
      .state('orders.list', {
        url: '/list',
        component: 'storeAdminOrdersList'
      })

      .state('Report', {
        parent: 'management',
        url: '/Report',
        controller: 'ecb.app.vendorAdmin.Report.controller',
        templateUrl: `${MyConstant.TemplateUrl}management/report.html`
      })

      .state('Discount', {
        parent: 'management',
        url: '/Discount',
        controller: 'DiscountController.Main',
        templateUrl: `${
          MyConstant.TemplateUrl
        }management/discount/discount.html`
      })
      .state('Discount.List', {
        url: '/List',
        controller: 'DiscountController.List',
        templateUrl: `${
          MyConstant.TemplateUrl
        }management/discount/discount.list.html`
      })
      .state('Discount.Create', {
        url: '/Create',
        controller: 'DiscountController.Create',
        templateUrl: `${
          MyConstant.TemplateUrl
        }management/discount/discount.Create.html`
      })
      .state('Discount.Edit', {
        url: '/Edit/:Id',
        controller: 'DiscountController.Edit',
        templateUrl: `${
          MyConstant.TemplateUrl
        }management/discount/discount.Edit.html`
      })

      // .state('Shipment', {
      //     parent: "management",
      //     url: '/Shipment',
      //     controller: 'ShipmentController.Main',
      //     templateUrl: `${MyConstant.TemplateUrl}management/shipment/shipment.html`
      // })
      // .state('Shipment.List', {
      //     url: '/List',
      //     controller: 'ShipmentController.List',
      //     templateUrl: `${MyConstant.TemplateUrl}management/shipment/shipment.list.html`
      // })
      // .state('Shipment.Create', {
      //     url: '/Create',
      //     controller: 'ShipmentController.Create',
      //     templateUrl: `${MyConstant.TemplateUrl}management/shipment/shipment.Create.html`
      // })
      // .state('Shipment.Edit', {
      //     url: '/Edit/:Id',
      //     controller: 'ShipmentController.Edit',
      //     templateUrl: `${MyConstant.TemplateUrl}management/shipment/shipment.Edit.html`
      // })

      .state('Warranty', {
        parent: 'management',
        url: '/Warranty',
        controller: 'WarrantyController.Main',
        templateUrl: `${
          MyConstant.TemplateUrl
        }management/warranty/warranty.html`
      })
      .state('Warranty.List', {
        url: '/List',
        controller: 'WarrantyController.List',
        templateUrl: `${
          MyConstant.TemplateUrl
        }management/warranty/warranty.list.html`
      })
      .state('Warranty.Create', {
        url: '/Create',
        controller: 'WarrantyController.Create',
        templateUrl: `${
          MyConstant.TemplateUrl
        }management/warranty/warranty.Create.html`
      })
      .state('Warranty.Edit', {
        url: '/Edit/:Id',
        controller: 'WarrantyController.Edit',
        templateUrl: `${
          MyConstant.TemplateUrl
        }management/warranty/warranty.Edit.html`
      })

      .state('manageMenu', {
        parent: 'management',
        url: '/manageMenu',
        component: 'bazaryabAdminMenu'
      })
      .state('manageComments', {
        parent: 'management',
        url: '/manageComments',
        controller: 'ManageCommentsCtrl',
        templateUrl: `${MyConstant.TemplateUrl}management/manageComments.html`,
        reloadOnSearch: false
      })

      .state('excel', {
        parent: 'management',
        url: '/excel',
        component: 'excel'
      })
      .state('excel.import', {
        url: '/import',
        component: 'excelImport'
      })
      .state('excel.export', {
        url: '/export',
        component: 'excelExport'
      });

    appRoute.map(route => {
      $stateProvider.state(route);
    });
  });

  app.config($mdToastProvider => {
    'ngInject';
    $mdToastProvider.addPreset('notify', {
      methods: ['textContent', 'parent', 'position', 'hideDelay'],
      options: function() {
        return {
          template: `
                    <md-toast  class="animated ng-zoomOut ng-flipInX notify">
                        <div class="md-toast-content">
                            {{toast.textContent}}
                            <i class="fa fa-times"  ng-click="toast.close()"></i>
                        </div>
                    </md-toast>`,
          controllerAs: 'toast',
          controller: function mdToastCtrl($mdToast) {
            'ngInject';

            this.close = () => {
              $mdToast.hide();
            };
          },
          bindToController: true
        };
      }
    });
    $mdToastProvider.addPreset('action', {
      methods: [
        'textContent',
        'parent',
        'position',
        'hideDelay',
        'action',
        'actionUrl',
        'highlightClass',
        'actionTarget'
      ],
      options: function() {
        return {
          template: `
                    <md-toast  class="animated ng-zoomOut ng-flipInX notify">
                        <div class="md-toast-content">
                            {{toast.textContent}}
                            <md-button target="{{toast.actionTarget}}" ng-href="{{toast.actionUrl}}" class="md-action" ng-if="toast.action" ng-click="toast.resolve()" ng-class="toast.highlightClasses">
                                {{ toast.action }}
                            </md-button>
                            <i class="fa fa-times"  ng-click="toast.close()"></i>
                        </div>
                    </md-toast>`,
          controllerAs: 'toast',
          controller: function mdToastCtrl($mdToast) {
            'ngInject';

            this.close = () => {
              $mdToast.hide();
            };

            this.resolve = () => {
              $mdToast.hide('ok');
            };
          },
          bindToController: true
        };
      }
    });
  });

  app.config($mdDialogProvider => {
    'ngInject';
    $mdDialogProvider.addPreset('login', {
      options: function() {
        return {
          template: `
                <md-dialog flex-xs="100" ng-class="{'md-dialog-fullscreen':dialog.$mdMedia('max-width: 600px')}" flex="50" class="custom_login"> 
                   
                    <login-view ></login-view> 
                </md-dialog>`,
          controllerAs: 'dialog',
          bindToController: true,
          controller: function mdDialogCtrl($mdDialog, $mdMedia) {
            'ngInject';
            var isPrompt = this.$type == 'prompt';

            if (isPrompt && this.initialValue) {
              this.result = this.initialValue;
            }
            this.$mdMedia = $mdMedia;
            this.abort = function() {
              $mdDialog.cancel();
            };
          },
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          escapeToClose: true
        };
      }
    });
  });

  app.config($mdThemingProvider => {
    'ngInject';
    $mdThemingProvider
      .theme('default')
      .primaryPalette('deep-orange')
      .accentPalette('blue-grey');

    $mdThemingProvider.theme('navBar').accentPalette('deep-orange');
  });

  app.config($mdDialogProvider => {
    'ngInject';
    $mdDialogProvider.addPreset('confirm', {
      methods: [
        'title',
        'textContent',
        'ok',
        'cancel',
        'doneTitle',
        'doneTextContent',
        'doneOk',
        'doneFN'
      ],
      options: function() {
        return {
          template: `
                <md-dialog class="confirm-dialog">
                    <div ng-if="!dialog.$done && !dialog.$error">
                        <div class="warning pulseWarning"> 
                            <span class="body pulseWarningIns"></span> 
                            <span class="dot pulseWarningIns"></span> 
                        </div>
                        <h2>{{ dialog.title }}</h2>
                        <p>{{ dialog.textContent }}</p>
                        <div>
                            <md-button class="md-raised" ng-click="dialog.done()" tabindex="1">{{ dialog.ok }}</md-button>
                            <md-button class="md-raised md-warn md-hue-2" ng-click="dialog.abort()" tabindex="2">{{ dialog.cancel }}</md-button> 
                        </div>
                    </div>   
                    <div ng-if="dialog.$done">
                        <div class="success animate" style="display: block;">
                            <span class="line tip animateSuccessTip"></span> 
                            <span class="line long animateSuccessLong"></span> 
                            <div class="placeholder"></div> <div class="fix"></div>
                        </div>
                        <h2>{{ dialog.doneTitle }}</h2>
                        <p>{{ dialog.doneTextContent }}</p>
                        <div>

                            <md-button class="md-raised md-primary" ng-click="dialog.hide()" tabindex="1">{{ dialog.doneOk }}</md-button>
                        </div>
                    </div>
                    <div ng-if="dialog.$error">
                        <div class="error pulseError"> 
                            <span class="body pulseErrorIns"></span> 
                            <span class="dot pulseErrorIns"></span> 
                        </div>
                        <h2>{{ dialog.errTitle }}</h2>
                        <p>{{ dialog.errTextContent }}</p>
                        <div>
                            <md-button class="md-raised" ng-click="dialog.done()" tabindex="1">{{ dialog.errRetry }}</md-button>
                            <md-button class="md-raised md-warn md-hue-2" ng-click="dialog.abort()" tabindex="2">{{ dialog.errCancel }}</md-button> 
                        </div>
                    </div>
                    <spn-loading ng-if="dialog.loading"></spn-loading> 
                </md-dialog>`,
          controller: function mdDialogCtrl($mdDialog, $mdConstant) {
            'ngInject';
            this.$done = false;
            this.ok = this.ok || 'بله انجام بده';
            this.title = this.title || 'آیا از انجام این کار مطمئن هستید؟';
            this.textContent =
              this.textContent || 'این عملیات غیر قابل بازگشت می باشد';
            this.doneOk = this.doneOk || 'انجام شد';
            this.doneTitle = this.doneTitle || 'انجام شد';
            this.doneTextContent =
              this.doneTextContent || 'در خواست شما با موفقیت انجام شد';
            this.errTitle = this.errTitle || 'خطایی رخ داده است.';
            this.errTextContent =
              this.errTextContent || 'در انجام عملیات مشکلی پیش آمده است';
            this.cancel = this.cancel || 'منصرف شدم';
            this.errCancel = this.errCancel || 'منصرف شدم';
            this.errRetry = this.errRetry || 'دوباره سعی کن';

            this.done = () => {
              if (this.doneFN && typeof this.doneFN === 'function') {
                this.loading = true;
                this.doneFN().then(
                  () => {
                    this.loading = false;
                    this.$done = true;
                  },
                  err => {
                    this.loading = false;
                    this.$error = true;
                  }
                );
              } else {
                this.hide(true);
              }
            };

            this.hide = function() {
              $mdDialog.hide(true);
            };
            this.abort = function() {
              $mdDialog.cancel();
            };
            this.keypress = function($event) {
              if ($event.keyCode === $mdConstant.KEY_CODE.ENTER) {
                $mdDialog.cancel();
              }
            };
          },
          controllerAs: 'dialog',
          bindToController: true,
          clickOutsideToClose: true,
          escapeToClose: true
        };
      }
    });
  });

  app.config($mdDialogProvider => {
    'ngInject';
    $mdDialogProvider.addPreset('ecb_confirm', {
      methods: [
        'title',
        'htmlContent',
        'textContent',
        'content',
        'ariaLabel',
        'ok',
        'cancel',
        'theme',
        'css'
      ],
      options: advancedDialogOptions
    });
    advancedDialogOptions.$inject = ['$mdDialog', '$mdTheming', '$mdConstant'];
    function advancedDialogOptions($mdDialog, $mdTheming, $mdConstant) {
      return {
        template: [
          '<md-dialog md-theme="{{ dialog.theme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
          '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
          '    <h2 class="md-title">{{ dialog.title }}</h2>',
          '    <div ng-if="::dialog.mdHtmlContent" class="_md-dialog-content-body" ',
          '        ng-bind-html="::dialog.mdHtmlContent"></div>',
          '    <div ng-if="::!dialog.mdHtmlContent" class="_md-dialog-content-body">',
          '      <p>{{::dialog.mdTextContent}}</p>',
          '    </div>',
          '  </md-dialog-content>',
          '  <md-dialog-actions>',
          '    <md-button ng-click="dialog.hide()" class="md-raised">',
          '      {{ dialog.ok }}',
          '    </md-button>',
          '    <md-button ng-click="dialog.abort()" class="md-raised">',
          '      {{ dialog.cancel }}',
          '    </md-button>',
          '  </md-dialog-actions>',
          '</md-dialog>'
        ]
          .join('')
          .replace(/\s\s+/g, ''),
        controller: function mdDialogCtrl() {
          var isPrompt = this.$type == 'prompt';

          if (isPrompt && this.initialValue) {
            this.result = this.initialValue;
          }

          this.hide = function() {
            $mdDialog.hide(isPrompt ? this.result : true);
          };
          this.abort = function() {
            $mdDialog.cancel();
          };
          this.keypress = function($event) {
            if ($event.keyCode === $mdConstant.KEY_CODE.ENTER) {
              $mdDialog.hide(this.result);
            }
          };
        },
        controllerAs: 'dialog',
        bindToController: true,
        parent: angular.element(document.body),
        targetEvent: Element,
        clickOutsideToClose: true,
        theme: $mdTheming.defaultTheme()
      };
    }
  });
  app.config(function(flowFactoryProvider, MyConstant) {
    'ngInject';
    flowFactoryProvider.defaults = {
      target: `${MyConstant.ApiUrl}Upload/GeneralUploader/?typeID=0`,
      // permanentErrors: [404, 500, 501],
      // maxChunkRetries: 1,
      // chunkRetryInterval: 5000,
      singleFile: true,
      testChunks: false
    };
    flowFactoryProvider.on('catchAll', function(event) {
      //
    });
  });

  app.filter('positive', function() {
    return function(input) {
      if (!input) {
        return 0;
      }
      return Math.abs(input);
    };
  });
  app.filter('toPersian', Filter);
  app.filter('enumToSelect', enumToSelect_filter);
  app.filter('Jdate', function($moment) {
    'ngInject';

    return function(input, format) {
      return $moment
        .date(input, 'YYYY-M-D HH:mm:ss')
        .format(format || 'jYYYY/jM/jD');
    };
  });
  app.filter('enums', enumsFilter);
  app.filter('translates', tranlatesFilter);
  app.filter('cut', function() {
    return function(value, wordwise, max, tail) {
      if (!value) return '';

      max = parseInt(max, 10);
      if (!max) return value;
      if (value.length <= max) return value;

      value = value.substr(0, max);
      if (wordwise) {
        var lastspace = value.lastIndexOf(' ');
        if (lastspace != -1) {
          value = value.substr(0, lastspace);
        }
      }

      return value + (tail || ' �');
    };
  });

  // Assign DNN Component to App
  app.component('userProfile', userProfileComponent);
  app.component('bazaryabAdmin', bazaryab_adminComponent);

  app.component('browsProduct', browsProductComponent);
  app.component('browsProductType', browsProductTypeComponent);
  app.component('browsCategory', browsCategoryComponent);
  app.component('browsCity', browsCityComponent);
  app.component('carousel', carouselComponent);
  app.component('gridList', gridListComponent);
  app.component('pagination', paginationComponent);
  app.component('productList', productListComponent);
  app.component('product', productComponent);
  app.component('productGridView', productGridViewComponent);
  app.component('productListView', productlistViewComponent);
  app.component('storeCart', storeCartComponent);
  app.component('storeMinCart', storeMinCartComponent);
  app.component('storeSearch', storeSearchComponent);
  app.component('storeManagement', storeManagementComponent);
  app.component('storeQuickAccess', storeQuickAccessComponent);
  app.component('storeCompare', storeCompareComponent);
  app.component('storeRegistration', storeRegistrationComponent);
  app.component('loginView', loginViewComponent);
  app.component('compareForm', compareFormComponent);
  app.component('slideShow', slide_show_component);
  app.component('countDownTimer', count_down_timer_component);
  app.component('storeCarousel', store_carousel_component);
  app.component('storeCarouselGrid', store_carousel_grid_component);
  app.component('storeCarouselList', store_carousel_list_component);
  app.component('storeCarouselCarousel', store_carousel_carousel_component);
  app.component('storeLogistic', logistic_component);
  app.component('checkoutLogin', checkout_login_component);
  app.component('bazaryabAdminMenu', bazaryab_admin_menu_component);
  app.service('$compare', compareService);
  app.service('$notify', notifyService);
  app.service('$mPath', modulePathService);
  app.service('$user', userService);
  app.service('$cart', cartService);
  app.service('$order', orderService);
  app.service('$quickAccess', QuickAccessService);
  function QuickAccessService($http, MyConstant) {
    'ngInject';
    this.GetNode = function(PageNumber, TypeID, ID, PageSize) {
      var PageSize = PageSize || 40;
      return $http.get(
        `${
          MyConstant.ApiUrl
        }ECBQuickAccessMenu/GetQuickAccessMenu/?TypeID=${TypeID}&id=${ID}&PageSize=${PageSize}&PageNumber=${PageNumber}`,
        { cache: false }
      );
    };
  }

  app.service('$VendorLoaction', VendrorLocation);
  function VendrorLocation($http) {
    'ngInject';
    this.List = function(TypeId, id, pageNumber, pageSize) {
      var pageSize = pageSize || 20;
      var pageNumber = pageNumber || 1;
      return $http.get(
        '/DesktopModules/ECBMainStore/ECBMainWebApi/API/ECBQuickAccessMenu/GetQuickAccessMapInfo/?TypeId=' +
          TypeId +
          '&id=' +
          id +
          '&latitude=null&longitude=null&pageNumber=' +
          pageNumber +
          '&pageSize=' +
          pageSize
      );
    };
  }

  app.factory('$profile', profileFactory);
  app.factory('$category', function($resource, MyConstant) {
    return $resource(
      `${MyConstant.ApiUrl}DataEntry_Category/GetTree_Category`,
      {},
      {
        All: {
          method: 'GET',
          url: `${MyConstant.ApiUrl}DataEntry_Category/GetTree_Category`
        },
        save: {
          method: 'POST',
          url: `${MyConstant.ApiUrl}DataEntry_Category/SaveCategory`
        },
        remove: {
          method: 'get',
          url: `${
            MyConstant.ApiUrl
          }DataEntry_Category/RemoveCategory?categoryID=:categoryID`
        },
        get: {
          method: 'get',
          url: `${
            MyConstant.ApiUrl
          }DataEntry_Category/GetCategory?categoryID=:categoryID`
        },
        query: {
          isArray: false,
          url: `${MyConstant.ApiUrl}Product/categories`,
          params: {
            PageNumber: '@PageNumber',
            PageSize: '@PageSize',
            Filters: '@Filters'
          }
        },
        byVendor: {
          isArray: true,
          url: `${
            MyConstant.ApiUrl
          }ECBTempGeneral/GetSubCategories?catID=null&vendorID=:vendorId`
        }
      }
    );
  });
  app.factory('CarouselService', function($http) {
    'ngInject';
    return {
      get: function(apiUrl, apiMethod, apiData) {
        var req = {
          method: apiMethod,
          url: apiUrl,
          data: apiData || null
        };
        return $http(req);
      }
    };
  });
  app.factory('$search', search_factory);
  app.factory('$amazingOffer', amazingOffer_factory);
  app.factory('$favorit', favoritFactory);
  app.factory('$availableAlert', availableFactory);
  app.factory('$vendor', vendorInfoFactory);
  app.factory('$geo', geoFactory);
  app.factory('CarouselService', function($http) {
    'ngInject';
    return {
      get: function(apiUrl, apiMethod, apiData) {
        var req = {
          method: apiMethod,
          url: apiUrl,
          data: apiData || null
        };
        return $http(req);
      }
    };
  });
  app.factory('ProductCompareService', function($http, MyConstant) {
    'ngInject';
    return {
      GetAllBrand: function(productTypeID) {
        var request = $http({
          method: 'get',
          url: `${
            MyConstant.ApiUrl
          }ECBManufacturer/GetManufacturerByPtypeID/?productTypeID=${productTypeID}`
        });
        return request;
      },
      GetAllProduct: function(productTypeID, manufacurerID) {
        var request = $http({
          method: 'get',
          url: `${
            MyConstant.ApiUrl
          }ECBProduct/GetProductByPtypeAndManID/?productTypeID=${productTypeID}&manufacurerID=${manufacurerID}`
        });
        return request;
      }
    };
  });

  app.directive('ecbAttrTargetBlank', function() {
    return {
      restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
      link: function($scope, iElm, iAttrs, controller) {
        if (iAttrs.ecbAttrTargetBlank == 'true') {
          iElm.attr('target', '_blank');
        }
      }
    };
  });
  app.directive('validate', validate_directive);
  app.directive('moveNextOnMaxlength', function() {
    return {
      restrict: 'A',
      link: function($scope, element) {
        element.on('input', function(e) {
          if (element.val().length == element.attr('maxlength')) {
            var $nextElement = element
              .parent()
              .next()
              .find('input');

            if ($nextElement.length) {
              $nextElement[0].focus();
            }
          }
        });
      }
    };
  });
  app.directive('formatAsCurrency', formatAsCurrency);
  app.directive('spnLoading', sepnaLoadingDirective);
  app.directive('backdropBasket', backdropBasket_directive);
  app.directive('customScrollBar', customScrollbar);
  app.directive('ecbTooltip', MdTooltipDirective);
  app.directive('countDownTimer', count_down_timer_directive);
  app.directive('scrollToTop', function($timeout) {
    'ngInject';
    return {
      restrict: 'A',
      scope: {
        trigger: '=scrollToTop'
      },
      link: function postLink(scope: any, elem) {
        scope.$watch('trigger', function() {
          if (scope.trigger) {
            var topOffset = $(elem).offset().top;
            var height = $(elem).innerHeight();
            var body = $('html, body');
            $timeout(() => {
              body
                .stop()
                .animate({ scrollTop: topOffset - height }, '500', 'swing');
            }, 500);
          }
        });
      }
    };
  });
  app.directive('errSrc', function(MyConstant) {
    'ngInject';
    return {
      link: function(scope, element, attrs: any) {
        element.bind('error', function() {
          if (attrs.src != MyConstant.errSrc[attrs.errSrc]) {
            attrs.$set('src', MyConstant.errSrc[attrs.errSrc]);
          }
        });
        if (!attrs.ngSrc) {
          attrs.$set('src', MyConstant.errSrc[attrs.errSrc]);
        }
      }
    };
  });
  app.directive('toggleMenu', toggleMenu_directive);
  app.directive('collapsed', collapsed_directive);
  app.directive('clickOutSide', clickOutSide_directive);
  app.directive('owlCarousel', OwlCarouselDirective);
});



// WEBPACK FOOTER //
// ./src/store-modules/app/app.ts